module.exports = __webpack_public_path__ + "img/client-4-new.3fa5c7c8.jpg";